import React, { useRef } from "react";
import CopyIcon from "../icons/copyicon";
import Loader from "./loader";
import AddFileIcon from "../icons/plusicon";
//import AWS from "aws-sdk";
import AWS from "aws-sdk";
//Service import
import service from "../services";
import DeletefileIcon from "../icons/DeletefileIcon";
export default function VideoImage({ textChange, item, handleImage, size, value, isboth ,image,iconDelete,showDeleteIcon,insideOnchange,deleteImage,videoPreLoader,isOnlyImage}) {
  const ref = useRef(null)
  return (
    <>
      <div className="media_image mb_0 absolute_loader relative">
        {videoPreLoader
          ? <Loader />
          : <img src={value ? value : '/images/image-placeholder.png'} alt="image" />
        }
       {isOnlyImage ? <span className="upload_message">{'Upload PNG/JPEG of max size of 2MB'}</span> :
      <span className="upload_message">{textChange ?"Upload PNG/JPEG of max size of 2MB OR MP4 of max size 200MB" : "Upload PNG/JPEG of max size of 2MB OR MP4 of max size 100MB"}</span> }
        <div className={`input_file ${showDeleteIcon?'active':''}`}>
          <input
            type="file"
            ref={ref}
            id={item}
            style={{ display: "none" }}
            onChange={handleImage}
            accept={isboth ? ".png, .jpg, .jpeg, video/mp4" : ".png, .jpg, .jpeg"}
          />
          <span onClick={() => { ref.current.click(); }}          >
            <AddFileIcon />
          </span>
        </div>
          {showDeleteIcon && iconDelete &&
            <span className="remove_file pointer "
              onClick={deleteImage}
            ><DeletefileIcon /></span>
          }
      </div>
        <div className="field_row">
          <div className="field_input relative">
            <input
              type="text"
              placeholder="https://cloudfront.aws.com/sdf2345"
              name='inSite'
              id={item}
              value={image}
              onChange={insideOnchange}
            />
            <span className="copy_box">
              <CopyIcon />
            </span>
          </div>
        </div> 
    </>
  )
}
